"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { TextScramble } from "@/components/ui/text-scramble";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="h-screen w-screen text-center flex flex-col items-center justify-center">
      <TextScramble
        className="font-mono text-xl text-[#FF0000]"
        duration={1.2}
        characterSet=". "
      >
        [ SOMETHING WENT WRONG ]
      </TextScramble>
      <div className="flex gap-2">
        <button onClick={() => reset()}>
          <TextScramble
            className="font-mono text-xs text-muted-foreground hover:underline"
            duration={1.2}
            characterSet=". "
          >
            TRY AGAIN
          </TextScramble>
        </button>
        <TextScramble
          className="font-mono text-xs text-muted-foreground"
          duration={1.2}
          characterSet=". "
        >
          |
        </TextScramble>
        <Link href={"/"}>
          <TextScramble
            className="font-mono text-xs text-muted-foreground hover:underline"
            duration={1.2}
            characterSet=". "
          >
            HOME
          </TextScramble>
        </Link>
      </div>
    </div>
  );
}
